import React from 'react';
import moment from 'moment';

import http from 'api/http';
import { manufacturerAPI, oilAPI } from 'api/requests';

import { downloadFile } from 'helpers';

export default class ESignDownloadSection extends React.Component {
  downloadLetter = () => {
    const {applicationId, name} = this.props;

    http.get(oilAPI.downloadBrandCertLetter(applicationId), {responseType: 'blob'})
      .then(({data})=>{
        downloadFile(data, `Brand_Certification_Letter_${name}.pdf`)
      })
  };

  downloadAgreement = (envelopeId, name) => () => {
    http
      .get(manufacturerAPI.eSignDocumentDownload(envelopeId, name), {
        responseType: 'blob'
      })
      .then(({data}) => {
        downloadFile(data, name);
      });
  };

  getDocumentReadableStatus = document => {
    if (document.status) {
      return document.status[0].toUpperCase() + document.status.slice(1).toLowerCase();
    }

    return '';
  };

  getDocumentsList = () => {
    const {licenseAgreementList} = this.props;

    if (!licenseAgreementList || !licenseAgreementList.length)
      return (
        <div className='list__row list__row_small' key={0}>
          <div className='list__row-item list__row-item_small _width_pc_100'>
            No documents of this type for selected brand
          </div>
        </div>
      );

    return licenseAgreementList.map((document, index) =>
      <div className='list__row list__row_small' key={index}>
        <div className='list__row-item list__row-item_small _width_pc_50'>
          {document.fileName}
        </div>
        <div className='list__row-item list__row-item_small _width_pc_20'>
          {this.getDocumentReadableStatus(document)}
        </div>
        <div className='list__row-item list__row-item_small _width_pc_15'>
          {moment(document.date).local().format('MM/DD/YYYY')}
        </div>
        <div className='list__row-item list__row-item_small list__row-item_component _width_pc_15'>
          <div className='__download-icon _cursor_pointer'
            onClick={this.downloadAgreement(document.id, document.fileName)} />
        </div>
      </div>)
  };

  render () {
    return(
      <section className='scene_section'>
        <header>Downloads</header>
        <div className='detailsScene__downloads-section-buttons-wrapper'>
          <div
            className='detailsScene__downloads-section-button'
            onClick={this.downloadLetter}
          >
            Oil Brand Certification Letter
          </div>
        </div>

        <div className='detailsScene__downloads-section-list-header'>
          Brand License Agreement
        </div>
        <div className='list__wrapper _border_all_1 _padding_left_20'>
          <div className='list__row list__header list__header_small _margin_bottom_16 _margin_top_12 _border_none'>
            <div className='list__row-item list__header-item_small _width_pc_50'>
              Document
            </div>

            <div className='list__row-item list__header-item_small _width_pc_20'>
              Status
            </div>

            <div className='list__row-item list__header-item_small _width_pc_15'>
              Date
            </div>

            <div className='list__row-item list__header-item_small _width_pc_15 _text_align_center'>
              Download
            </div>
          </div>
          {this.getDocumentsList()}
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/brand/Application/Details/ESignDownloadSection.jsx